module.exports = __webpack_public_path__ + "static/media/inactive-policy-background.1da7d64e.svg";